export default (pageName = "", slug = "") => ({
  public: false,
  bookmarkName: "",
  tagLabel: pageName,
  tagSlug: slug,

  init() {
    this.pageName = pageName;
    this.bookmarkName = pageName;
    this.postName = pageName;

    this.pageSlug = slug;
    this.postSlug = slug;
    this.bookmarkSlug = slug;
  },

  slugify(event: Event) {
    let str = (event.target as HTMLInputElement).value.replace(/^\s+|\s+$/g, "");
    str = str.toLowerCase();
    str = str
      .replace(/[^a-z0-9 -]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");

    this.pageSlug = str;
    this.postSlug = str;
    this.bookmarkSlug = str;
    this.tagSlug = str;
  },
});
